import { FactoryTypes, FieldID } from "../../../models";

export const iphoneToIphoneSetupWithPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.makeSureConnectedToWifi,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.doYouKnowAppleIdAndPasswordQuestion,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findYourAppleId.text,
            image: FieldID.guideContainer.steps.findYourAppleId.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetAppleIdPassword.text,
            image: FieldID.guideContainer.steps.resetAppleIdPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.ifTwoFactorEnabled.text,
            image: FieldID.guideContainer.steps.ifTwoFactorEnabled.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.ifTwoFactorDisabled.text,
            image: FieldID.guideContainer.steps.ifTwoFactorDisabled.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.turnOnNewPhoneStep.text,
            image: FieldID.guideContainer.steps.turnOnNewPhoneStep.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.setupWithAppleId.text,
            image: FieldID.guideContainer.steps.setupWithAppleId.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.followiPhoneSetupSteps.text,
            image: FieldID.guideContainer.steps.followiPhoneSetupSteps.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.setupFaceAndTouchId.text,
            image: FieldID.guideContainer.steps.setupFaceAndTouchId.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iphoneTransferYourData.text,
            image: FieldID.guideContainer.steps.iphoneTransferYourData.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.waitUntilContentTransferred.text,
            image:
              FieldID.guideContainer.steps.waitUntilContentTransferred.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];

export const iphoneToIphoneSetupLostPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.makeSureConnectedToWifi,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.appleSetupQuickStart.text,
            image: FieldID.guideContainer.steps.appleSetupQuickStart.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.appleSetupFromBackup.text,
            image: FieldID.guideContainer.steps.appleSetupFromBackup.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.appleSetupRestoreFromICloud.text,
            image:
              FieldID.guideContainer.steps.appleSetupRestoreFromICloud.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];
